export enum AutomatedCollectionTab {
  INTEGRATIONS = "integrations",
  UTILITY_CONNECTIONS = "utilityConnections",
}
